<template>
    <div>
        <h2>{{stempelCounter}} von 10 Stempel</h2>
        <div class="mt-3 mb-3 blink_me" v-if="stempelCounter >= 10">Du hast es geschafft! Deine Stempelkarte ist voll und
            jetzt kannst du dein Guthaben von
            <b>{{$store.getters.stempelRabattAmount}} Euro</b> bei der nächsten Bestellung einlösen oder
            bei einer zukünftigen Bestellung deiner Wahl.
        </div>
    </div>
</template>

<script>
    export default {
        name: "StempelAnzahl",
        computed: {
            stempelCounter() {
                let p = this.$store.getters.stempelkarte.punktestand;
                let r = 0;
                if (p > 0) {
                    r = 1;
                }
                let t = Math.trunc(p / 10);
                if (t > 1) {
                    r = t;
                }
                if (r > 10) {
                    r = 10;
                }
                return r;
            },
        }

    }
</script>

<style scoped lang="scss">
    .blink_me {
        animation: blinker 0.7s linear infinite;
    }

    @keyframes blinker {
        50% {
            opacity: 40%;
        }
    }
</style>
